import httpRequest from 'httpRequest'
import {
    InventoryAdjustmentContract,
    ItemInventoryContract,
    SummaryInventoryItemContract,
} from 'models'

const INVENTORY_PREFIX = '/location/inventory'

const inventoryService = {
    getInventories: () =>
        httpRequest.get<ItemInventoryContract[]>(INVENTORY_PREFIX),
    getInventorySummary: () =>
        httpRequest.get<SummaryInventoryItemContract>(
            `${INVENTORY_PREFIX}/summary`,
        ),
    getInventoryItem: (id: string) =>
        httpRequest.get<ItemInventoryContract>(`${INVENTORY_PREFIX}/${id}`),
    adjustItemInventory: (id: string, payload: InventoryAdjustmentContract) =>
        httpRequest.post(
            `${INVENTORY_PREFIX}/${id}/adjust-item-inventory`,
            payload,
        ),
    updateSafetyStock: (id: string, payload: InventoryAdjustmentContract) =>
        httpRequest.put(
            `${INVENTORY_PREFIX}/${id}/update-safety-stock`,
            payload,
        ),
    checkOrderStockAvailability: (orderID: string) =>
        httpRequest.post(
            `${INVENTORY_PREFIX}/${orderID}/check-stock-availability`,
        ),
}

export default inventoryService
